import React from "react";
import { ShieldCheck } from "lucide-react";
import { useI18n } from "../i18n";

export default function TrustSection() {
  const { d } = useI18n();
  return (
    <section data-testid="trust-section" className="border-y border-jlo-gold/15 bg-jlo-bg2">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16 text-center">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-jlo-gold/40 text-jlo-gold mb-6">
          <ShieldCheck className="h-6 w-6" aria-hidden="true" />
        </span>
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-jlo-warm">{d.trust.heading}</h2>
        <p className="mt-5 text-base text-jlo-warm/75 leading-relaxed">{d.trust.body}</p>
      </div>
    </section>
  );
}
